import React from 'react';
import './privacypolicy.css';
import { useNavigate } from 'react-router-dom'; // Import the useNavigate hook
import { FaArrowLeft } from 'react-icons/fa';  // Import the left arrow icon

function PrivacyPolicy() {
  const navigate = useNavigate();  // Initialize the navigate function
  return (
    <div className="privacy-policy-container">
      <div className="back-button" onClick={() => navigate(-1)}>
        <FaArrowLeft className="back-icon" /> <span>Back</span>
      </div>
      <h1>Privacy Policy</h1>

      <p><em>Last updated: June 14, 2026</em></p>

      <p>This Privacy Policy explains how Quibly ("Quibly", "we", "us", "our") collects, uses, shares, and protects your personal information when you use the Quibly website and services (the "Service"). By using the Service, you agree to the practices described here and in our <a href="/termsandconditions">Terms of Service</a>.</p>

          <h2>Information We Collect</h2>

          <p>We collect the following categories of information:</p>
          <ul>
              <li><strong>Account information.</strong> Your email address and a securely hashed password when you register, along with whether and when you accepted our Terms.</li>
              <li><strong>Profile and resume data.</strong> Information you choose to add to your profile and resumes, such as your name, contact details, links (e.g., LinkedIn, GitHub, portfolio), work experience, education, projects, skills, and publications.</li>
              <li><strong>Job-targeting information.</strong> Job descriptions, postings, or URLs you provide so we can tailor your resume.</li>
              <li><strong>Payment information.</strong> If you purchase a paid plan, billing is processed by Stripe. We receive limited information such as your subscription status and the last digits/brand of your card; we do not store your full card number on our servers.</li>
              <li><strong>Usage and technical data.</strong> Log information such as IP address, browser type, timestamps, and actions taken in the Service, used to operate, secure, and improve the Service.</li>
          </ul>

          <h2>How We Use Your Information</h2>

          <p>We use your information to:</p>
          <ul>
              <li>Provide, operate, maintain, and improve the Service;</li>
              <li>Generate and tailor resume content based on the information you supply;</li>
              <li>Create and manage your account and process your subscription and payments;</li>
              <li>Communicate with you about your account, verification, security, and support;</li>
              <li>Detect, prevent, and address fraud, abuse, and security issues; and</li>
              <li>Comply with our legal obligations.</li>
          </ul>

          <p>We do not sell your personal information, and we do not use it for third-party advertising.</p>

          <h2>AI Processing</h2>

          <p>To generate and tailor resumes, we send the relevant profile and job information you provide to third-party artificial-intelligence providers acting as our processors. This is done to deliver the feature you request. You should avoid submitting information you do not wish to be processed for this purpose.</p>

          <h2>Service Providers We Share Data With</h2>

          <p>We share information only with service providers who help us run the Service, under agreements that require them to protect your data. These include:</p>
          <ul>
              <li><strong>Stripe</strong> – payment processing;</li>
              <li><strong>AI/model providers</strong> – generating and tailoring resume content;</li>
              <li><strong>Hosting and database providers</strong> – storing and serving the Service;</li>
              <li><strong>Email delivery providers</strong> – sending verification and account emails.</li>
          </ul>
          <p>We may also disclose information if required by law or to protect the rights, safety, and security of Quibly and its users.</p>

          <h2>Data Retention</h2>

          <p>We retain your account and profile data for as long as your account is active. When you delete your account, we delete or anonymize your personal data, except where we must retain certain information to comply with legal obligations, resolve disputes, or enforce our agreements.</p>

          <h2>Security</h2>

          <p>We use reasonable, industry-standard safeguards to protect your information, including encryption in transit, encryption of sensitive data at rest, hashed passwords, and access controls. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security. You use the Service and provide your information at your own risk.</p>

          <h2>Your Rights</h2>

          <p>Depending on where you live, you may have rights regarding your personal information, including the right to access, correct, delete, or export your data, and to object to or restrict certain processing. Many of these actions can be performed directly in your account; otherwise, you can contact us to make a request, and we will respond within the time required by applicable law.</p>

          <h3>California (CCPA/CPRA)</h3>
          <p>California residents have the right to know what personal information we collect, to request deletion, and to not be discriminated against for exercising these rights. We do not sell or share personal information for cross-context behavioral advertising.</p>

          <h3>EEA/UK (GDPR)</h3>
          <p>If you are in the EEA or UK, our legal bases for processing are: performance of our contract with you (to provide the Service), your consent (where applicable), our legitimate interests (to secure and improve the Service), and compliance with legal obligations. You may also lodge a complaint with your local data-protection authority.</p>

          <h2>Children's Information</h2>

          <p>The Service is not directed to children. We do not knowingly collect personal information from children under 16. If you believe a child has provided us personal information, please contact us and we will take steps to delete it.</p>

          <h2>Changes to This Policy</h2>

          <p>We may update this Privacy Policy from time to time. If we make material changes, we will update the date above and, where appropriate, notify you. Your continued use of the Service after changes take effect constitutes acceptance of the updated policy.</p>

          <h2>Contact Us</h2>

          <p>If you have questions or requests regarding this Privacy Policy or your data, please contact us through the Service.</p>
          </div>
);
}

export default PrivacyPolicy;
